export const CREDITS_AUTOMATION_SLICE_NAME = "creditsAutomation"
